import type { FaireProductEntity } from "../../entity_types/product";

export const p_vpvpnz9qgx: FaireProductEntity = {
  token: "p_vpvpnz9qgx",
  type: "product",
  name: "Pure Orange Juice - Emile Vergeois - Glass Bottle",
  brandToken: "b_puxke2dnj7",
  brandName: "Apricot & Honey Gourmet",
  imageUrl:
    "https://cdn.faire.com/fastly/f67ce6dff4dbb86bc2138656a65b00ebae4ee8eac6840020ea10a952d89c44de.jpeg",
  galleryImageUrls: [],
  priceDollars: 6.51,
  description:
    "Experience the authentic taste of France with Apricot & Honey Gourmet's Pure Orange Juice. Sourced from the finest orchards and bottled in elegant glass, this juice is a testament to our commitment to bring gourmet tastes to your table. This beverage offers a refreshing experience. It's more than just a juice; it's a celebration of artisanal French craftsmanship in a bottle. Enjoy it chilled for a unique taste experience.",
  tags: [],
  msrpDollars: 9.7,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:55:38.700Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
